export function validateURLs(urls: string[]) {
  const urlList = urls.map((url) => url.trim()).filter((url) => url.length > 0);

  if (urlList.length === 0) {
    return false;
  }

  // Validate URLs
  const invalidUrls = urlList.filter((url) => {
    try {
      new URL(url);
      return false;
    } catch {
      return true;
    }
  });

  return invalidUrls.length === 0;
}
